import React, { Component, Fragment } from 'react';
import { navigate } from 'gatsby';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import _map from 'lodash/map';
import _includes from 'lodash/includes';
import _concat from 'lodash/concat';
import _get from 'lodash/get';
import Modal from 'react-modal';
import Select from 'components/asic/Select';
import Cross from 'components/asic/Cross';
import AsicModelSwitch from 'components/asic/AsicModelSwitch';
import Link from 'components/Link';
import book from 'utils/images/book_dark.svg';
import bookWhite from 'utils/images/book_white.svg';
import hiveOsLogo from 'utils/images/hiveon-logo.svg';
import WL, { WL_BIGMINER } from 'constants/whiteLabel';
import languages from 'constants/languages';
import gs from 'pages/pages.module.css';
import s from 'pages/homeStyles.module.css';
import style from './asicIntro.module.css';

const customStyles = {
  content : {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    background: '#383e4a',
    padding: '15px 15px',
    borderRadius: '4px',
    border: 'none',
    overflow: 'visible',
  }
};

const mskMinerLinks = {
  [languages.EN]: 'https://mskminer.com/en/hiveos/',
  [languages.RU]: 'https://mskminer.com/ru/hiveos/',
}

const s17models = [
  'Antminer S17/S17+/S17e, S17PRO',
];

const t17models = [
  'Antminer T17/T17+/T17e',
];

const t9models = [
  'Antminer T9+',
];

const s9models = [
  'Antminer S9/S9j/S9i',
];

const l3models = [
  'Antminer L3+/L3++',
];

const allOther = [
  'Antminer A3',
  'Antminer B3',
  'Antminer D3/D3(Blissz)',
  'Antminer DR3',
  'Antminer E3',
  'Antminer S7',
  'Antminer S9SE/S9-Hydro/S9(VNISH)/S9(mskminer)/S11',
  'Antminer S15',
  'Antminer T9',
  'Antminer T15',
  'Antminer X3',
  'Antminer Z9/Z9-Mini',
  'Antminer Z11',
  'Innosilicon A5/A8 (need test)',
  'Innosilicon A9 ZMaster',
  'Innosilicon D9 DecredMaster',
  'Innosilicon S11 SiaMaster',
  'Innosilicon T3 BTCMiner',
  'Innosilicon T3H+/T3+/T2Th+/T2Thf+/T2Thl+/T2Th/T2Tz-30T/T2Thm/T2Thf/T2T+(32T)/T2Ts-26T/T2Ti-25T/T2T-24T',
  'Zig Z1/Z1+'
];

const quantityOptions = [
  { value: '1-2', label: '1-2' },
  { value: '3+', label: '3+' },
];

class AsicIntro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      model: this.getModelOptions()[0],
      quantity: quantityOptions[0],
      isHiveUser: false,
    };
  }

  openModal = () => {
    this.setState({ modalIsOpen: true });
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }

  getModelOptions = () => {
    if (WL.key === WL_BIGMINER) {
      return _map(
        _concat(s17models, s9models, l3models),
        option => ({ value: option, label: option }),
      );
    }

    return _map(
      _concat(s17models, t17models, t9models, s9models, l3models, allOther),
      option => ({ value: option, label: option }),
    );
  }

  handleModelChange = value => {
    this.setState({ model: value });
  }

  handleQuantityChange = value => {
    this.setState({ quantity: value });
  }

  handleNotHiveUserCheck = () => {
    this.setState({ isHiveUser: false });
  }

  handleHiveUserCheck = () => {
    this.setState({ isHiveUser: true });
  }

  goToGuide = () => {
    const { model, quantity, isHiveUser } = this.state;

    if (_includes(s17models, model.value)) {
      navigate('/hiveon-asic-firmware-S17-S17-Pro-s17installation/');
      return;
    }

    /* ============================ */
    /* T17 */

    if (_includes(t17models, model.value)) {
      navigate('/hiveon-asic-firmware-T17_T17+_T17e-t17installation/');
      return;
    }

    /* ============================ */
    /* T9 */

    if (
      _includes(t9models, model.value)
      && quantity.value === quantityOptions[0].value
      && !isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-T9+-t9installation#Installing-using-ASIC%E2%80%99s-web-interface/');
      return;
    }

    if (
      _includes(t9models, model.value)
      && quantity.value === quantityOptions[1].value
      && !isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-T9+-t9installation#Bulk-Installation/');
      return;
    }

    if (
      _includes(t9models, model.value)
      && quantity.value === quantityOptions[0].value
      && isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-T9+-t9installation#Updating-using-Hive-OS%E2%80%99s-web-interface/');
      return;
    }

    if (
      _includes(t9models, model.value)
      && quantity.value === quantityOptions[1].value
      && isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-T9+-t9installation#Bulk-Update/');
      return;
    }

    /* ============================ */
    /* L3+ */

    if (
      _includes(l3models, model.value)
      && quantity.value === quantityOptions[0].value
    ) {
      navigate('/hiveon-asic-firmware-L3+_L3++-L3+_L3++_installation/');
      return;
    }

    if (
      _includes(l3models, model.value)
      && quantity.value === quantityOptions[1].value
    ) {
      navigate('/hiveon-asic-firmware-L3+_L3++-L3+_L3++_installation#Option-2-Bulk-Installation/');
      return;
    }

    /* ============================ */
    /* S9 */

    if (
      _includes(s9models, model.value)
      && quantity.value === quantityOptions[0].value
      && !isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-S9-(S9i-S9j)-s9installation#Installing-using-ASIC’s-web-interface/');
      return;
    }

    if (
      _includes(s9models, model.value)
      && quantity.value === quantityOptions[1].value
      && !isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-S9-(S9i-S9j)-s9installation#Bulk-Installation/');
      return;
    }

    if (
      _includes(s9models, model.value)
      && quantity.value === quantityOptions[0].value
      && isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-S9-(S9i-S9j)-s9installation#Updating-using-Hive-OS%E2%80%99s-web-interface/');
      return;
    }

    if (
      _includes(s9models, model.value)
      && quantity.value === quantityOptions[1].value
      && isHiveUser
    ) {
      navigate('/hiveon-asic-firmware-S9-(S9i-S9j)-s9installation#Bulk-Update/');
      return;
    }

    navigate('/guides-add-asic-to-hiveos/');
  }

  renderInfo() {
    const { model, quantity } = this.state;

    if (
      _includes(t9models, model.value)
      || _includes(s9models, model.value)
    ) {
      return this.renderCheckboxes();
    }

    if (_includes(s17models, model.value)) {
      return(
        <Fragment>
          <div className={style.darkbgWrap}>
            <div><b><FormattedMessage id="AsicIntro.letInstall" defaultMessage="Let’s Install" /></b></div>
            <div className={style.installText}>
              <FormattedMessage id="AsicIntro.caption4" defaultMessage="There are three ways to install Hiveon ASIC firmware for S17, S17 Pro, S17+ and S17E — everything depends on the stock firmware release date. We will cover all the options, so you will be able to install Hiveon ASIC firmware quickly and easily." />
            </div>
          </div>
        </Fragment>
      );
    }

    if (_includes(t17models, model.value)) {
      return(
        <Fragment>
          <div className={style.darkbgWrap}>
            <div><b><FormattedMessage id="AsicIntro.letInstall" defaultMessage="Let’s Install" /></b></div>
            <div className={style.installText}>
            <FormattedMessage id="AsicIntro.caption5" defaultMessage="There are three ways to install Hiveon ASIC firmware for T17, T17+ and T17E — everything depends on the stock firmware release date. We will cover all the options, so you will be able to install Hiveon ASIC firmware quickly and easily." />
            </div>
          </div>
        </Fragment>
      );
    }

    if (_includes(l3models, model.value)) {
      return(
        <Fragment>
          <div className={style.darkbgWrap}>
            <div><b><FormattedMessage id="AsicIntro.letInstall" defaultMessage="Let’s Install" /></b></div>
            <div className={style.installText}>
            <FormattedMessage id="AsicIntro.caption6" defaultMessage="There are three scenarios of installing or updating your machines with Hiveon ASIC firmware. We will cover all of them." />
            </div>
          </div>
        </Fragment>
      );
    }

    if (
      _includes(allOther, model.value)
      && quantity.value === quantityOptions[0].value
    ) {
      return this.renderLetsInstallOtherOne();
    }

    if (
      _includes(allOther, model.value)
      && quantity.value === quantityOptions[1].value
    ) {
      return this.renderLetsInstallOtherMany();
    }
  }

  renderLetsInstallOtherOne() {
    return(
      <Fragment>
        <div className={style.darkbgWrap}>
          <div><b><FormattedMessage id="AsicIntro.letInstall" defaultMessage="Let’s Install" /></b></div>
          <div className={style.installText}>
            <div>1. <FormattedMessage id="AsicIntro.caption7" defaultMessage="Optimal variant for yours ASIC it's HIVE CLIENT" /></div>
            <div>2. <FormattedMessage id="AsicIntro.caption8" defaultMessage="One time installation" /></div>
            <ul className={style.installTextList}>
              <li><FormattedMessage id="AsicIntro.caption9" defaultMessage="Web interface or BTC-tools" /></li>
              <li><FormattedMessage id="AsicIntro.ssh" defaultMessage="SSH" /></li>
            </ul>
          </div>
        </div>
      </Fragment>
    );
  }

  renderLetsInstallOtherMany() {
    return(
      <Fragment>
        <div className={style.darkbgWrap}>
          <div><b><FormattedMessage id="AsicIntro.letInstall" defaultMessage="Let’s Install" /></b></div>
          <div className={style.installText}>
            <div>1. <FormattedMessage id="AsicIntro.caption10" defaultMessage="Optimal variant for yours ASIC it's HIVE CLIENT" /></div>
            <div>2. <FormattedMessage id="AsicIntro.caption11" defaultMessage="Bulk installation" /></div>
          </div>
        </div>
      </Fragment>
    );
  }

  renderCheckboxes() {
    const { isHiveUser } = this.state;

    return(
      <Fragment>
        <div className={style.darkbgWrap}>
          <div className={cx(style.checkbox)}>
            <input
              type="checkbox"
              onChange={this.handleNotHiveUserCheck}
              checked={!isHiveUser}
              id="new"
              className={style.customCheckbox}
            />

            { /* eslint-disable-next-line */ }
            <label htmlFor="new">
              <FormattedMessage id="AsicIntro.caption12" defaultMessage="I’m new to Hive OS" />
            </label>
          </div>
        </div>
        <div className={style.darkbgWrap}>
          <div className={cx(style.checkbox)}>
            <input
              type="checkbox"
              onChange={this.handleHiveUserCheck}
              checked={isHiveUser}
              id="existing"
              className={style.customCheckbox}
            />
            { /* eslint-disable-next-line */ }
            <label htmlFor="existing">
              <FormattedMessage id="AsicIntro.caption13" defaultMessage="I’m already Hive OS user" />
            </label>
          </div>
        </div>
      </Fragment>
    );
  }

  render() {
    const { modalIsOpen, model, quantity } = this.state;
    const { selected, intl } = this.props;
    const mskMinerLink = mskMinerLinks[intl.locale] || '';

    return (
     <section className={cx(style.root, gs.topUnderSub)}>
      <div className={style.background}>
        <div className={cx(gs.wrapper, s.wrapper)}>
          <div className={style.intro}>
            <div className={style.msg}>
              <h1 className={style.title}>
                <FormattedMessage id="AsicIntro.title" defaultMessage="Game-changing Firmware" />
              </h1>
              <div className={style.text}>
                <div className={style.textItem}>
                  <FormattedMessage
                    id="AsicIntro.caption1"
                    defaultMessage="Get max from your ASICs with Hiveon ASIC firmware powered by {mskMinerLink}. Manual and automatically settings for getting the extra hashrate, high protection from viruses, and bunch of Hive OS features to manage all the farms even easily."
                    values={{
                      mskMinerLink: <Link external href={mskMinerLink} className={gs.link}>MSKMINER</Link>
                    }}
                  />
                </div>
              </div>
            </div>
            {
              WL.showAsicGuide ? (
                <div className={style.guideWrapper}>
                  <div className={style.guideButton}>
                    <div
                      className={cx(style.buttonInstall,
                        { [style.buttonInstallLessFont]: _get(this.props, 'intl.locale') === languages.RU }
                      )}
                      onClick={this.openModal}
                      role="presentation"
                    >
                      <div className={style.imgInstallWrap}>
                        <img src={bookWhite} width="25" height="25" alt="go to guide icon" />
                      </div>
                      <div>
                        <span><FormattedMessage id="AsicIntro.installGuide" defaultMessage="Installation guide" /></span>
                      </div>
                    </div>
                  </div>
                  <div className={style.logoCaption}>
                    <img className={style.logo} src={hiveOsLogo} alt="logo" />
                    <span>
                      <FormattedMessage
                        id="AsicIntro.forFree"
                        defaultMessage="for {free}"
                        values={{ free: <span className={style.orange}><FormattedMessage id="AsicIntro.freeLower" defaultMessage="free" /></span> }}
                      />
                    </span>
                  </div>
                </div>
              ) : null
            }
          </div>
          <AsicModelSwitch selected={selected} />
        </div>
        <Modal
          ariaHideApp={false}
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          overlayClassName={style.modal}
        >
          <div className={style.cross}>
            <Cross onClick={this.closeModal} />
          </div>
          <div className={style.modelTitle}>
            <FormattedMessage id="AsicIntro.installGuide" defaultMessage="Installation Guide" />
          </div>
          <div className={style.wrap}>
            <div className={style.models}>
              <Select
                title={<FormattedMessage id="AsicIntro.asicModel" defaultMessage="ASIC Model" />}
                options={this.getModelOptions()}
                value={model}
                onChange={this.handleModelChange}
                isSearchable={false}
                />
            </div>
            <div className={style.count}>
              <Select
                title={<FormattedMessage id="AsicIntro.quantity" defaultMessage="Quantity" />}
                options={quantityOptions}
                value={quantity}
                onChange={this.handleQuantityChange}
                isSearchable={false}
                />
            </div>
          </div>
          <div className={style.contentWrap}>
            {this.renderInfo()}
          </div>
          <div className={style.buttonWrap}>
            <button className={style.button} onClick={this.goToGuide}>
              <img src={book} width="25" height="25" alt="go to guide icon" />
              <FormattedMessage id="AsicIntro.goToGuide" defaultMessage="Go to Guide" />
            </button>
          </div>
          </Modal>
        </div>
      </section>
    );
  }
}


export default injectIntl(AsicIntro);
